import { render } from "./SimpleRsvPopup.vue?vue&type=template&id=0cf812ec"
import script from "./SimpleRsvPopup.vue?vue&type=script&lang=js"
export * from "./SimpleRsvPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__